module.exports = {
      id: "photo-outline-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#photo-outline",
      toString: function () {
        return this.url;
      }
    }